import React from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';
import { i18n, Container, CookieService } from '../../../../symphony';
import s from './LanguageSwitcher.scss';

type LanguageSwitcherProps = {
  showLabel?: boolean;
};

export function LanguageSwitcher({ showLabel = false }: LanguageSwitcherProps) {
  useStyles(s);
  const supportedLanguages: { code: string; language: string; }[] = typeof window === 'undefined'
    ? Container.take('global', 'supportedLanguages')
    : (window as any).initialData?.supportedLanguages;

  const switchLanguage = (newLang: string) => {
    const cookieService = Container.take('global', CookieService);
    cookieService.setCookie('sl-language', newLang);
    const currentPath = window.location.pathname;
    const pathSegments = currentPath.split('/');

    if (pathSegments[1]) {
      pathSegments[1] = newLang;
    }

    const newPath = pathSegments.join('/');
    window.location.href = newPath;
  };

  return (
    <div className="sl-language-switcher-container">
      {showLabel && (
        <label className="sl-language-switcher-label">
          {i18n.t('web-footer.language-switcher-title')}
        </label>
      )}
      <select
        value={i18n.language}
        className="sl-language-switcher-select"
        onChange={(e) => switchLanguage(e.target.value)}
      >
        {supportedLanguages?.map((supportedLanguage) => (
          <option
            value={supportedLanguage.code}
            key={supportedLanguage.code}
          >
            {supportedLanguage.language}
          </option>
        ))}
      </select>
    </div>
  );
}
